import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getBeneficiaryByCustomer(customer_uid){
  return request({
    url: `/api/beneficiaries/customer/${customer_uid}`,
    method: "get"
  });
}

export function getBeneficiaryBy(customer_uid){
  return request({
    url: `/api/beneficiaries/${customer_uid}`,
    method: "get"
  });
}
export function getBeneficiaryByProject(project_id){
  return request({
    url: `/api/beneficiaries/project/${project_id}`,
    method: "get"
  });
}

export function addBeneficiaryProject(project_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/beneficiaries/project/${project_id}`,
    method: "post",
    data: data
  });
}
export function updateBeneficiary(customer_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/beneficiaries/${customer_uid}`,
    method: "put",
    data: data
  });
}

export function delBeneficiary(customer_uid){
  return request({
    url: `/api/beneficiaries/${customer_uid}`,
    method: "delete",
    data:{idempotency: uuid.v1()}
  });
}